// frontend
// --
export const INPUT_DEBOUNCE_TIME = 250; // ms

export const GEO_APPROX_DEG_KM_CONVERSION_FACTOR = 110.25;
export const GEO_APPROX_DEG_MI_CONVERSION_FACTOR = 68.5061739;
export const MILE_METER_CONVERSION_FACTOR = 1609.344; // there are this many meters in one mile

// program categories (high school or elementary school)
export const PROGRAM_CATEGORY_HS = "HS";
export const PROGRAM_CATEGORY_ES = "ES";


export const HS_PROGRAMS_URL = "data/hs-programs.json";
export const NON_HS_PROGRAMS_URL = "data/non-hs-programs.json";
export const SE_CUTOFF_SCORES_URL = "data/se-cutoff-scores.json";
export const NON_SE_CUTOFF_SCORES_URL = "data/non-se-cutoff-scores.json";
export const PROGRAM_TYPE_ID_TABLE_URL = "data/program-type-id-table.json";
export const SCHOOL_ATTENDANCE_BOUNDARY_TABLE_URL = "data/school-attendance-boundary-table.json";
export const TRACT_TIER_TABLE_URL = "data/tract-tier-table.json";
